<script>
  export let board
</script>

{#if board.news && board.news !== ''}
  <div class='card card-body mb-1 p-1'>
    {@html board.newsHTML}
  </div>
{/if}
